import { render, staticRenderFns } from "./ResHubLogo.vue?vue&type=template&id=6c562b0c"
import script from "./ResHubLogo.vue?vue&type=script&lang=js"
export * from "./ResHubLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports